module.exports = __webpack_public_path__ + "static/media/timeline-step-4.27bbcf06.png";